const VoucherTypeSetting = {
  OneTimeClaim: "one-time",
  AutoSeed: "auto-seed",
  MultiClaimGeneric: "multi-claim",
};

export default VoucherTypeSetting;
